import * as braze from '@braze/web-sdk';

import {
  LoggerFactory, FEATURE, DOMAIN, EVENT, DATASOURCE,
} from 'Services/Logger';

import {
  ifProd,
  isProd,
  isLocal,
  isDevMode,
} from './env';

const pathServiceWorker = isLocal() ? '/service_worker.js' : '/pay/service_worker.js';
/**
 * Intialize SDK Integration with vendor (Braze).
 * Required for interaction between Kueski and users by push notifications and in-app messages.
 */
export const initNotificationsSdk = () => {
  const {
    PRODUCTION_BRAZE_APP_ID,
    STAGING_BRAZE_APP_ID,
  } = process.env;

  braze.initialize(
    ifProd(PRODUCTION_BRAZE_APP_ID, STAGING_BRAZE_APP_ID),
    {
      allowUserSuppliedJavascript: true,
      baseUrl: 'sdk.iad-05.braze.com',
      doNotLoadFontAwesome: true,
      enableLogging: !isProd(),
      manageServiceWorkerExternally: true,
      serviceWorkerLocation: pathServiceWorker,
    },
  );
};

/**
 * Registers Service Worker file.
 * File is requiered so we can catch push notifications or in-app messages.
 */
export const initServiceWorker = () => {
  const Logger = LoggerFactory.getLogger(DOMAIN.NOTIFICATIONS);
  const SECTION = 'index';
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(pathServiceWorker).then(
      (registration) => {
        /**
         * Ensure requesting push notification permissions won't break the experience
         * on Merchants' WebViews before enabling this feature.
         *
         * As context, some of the WebViews doesn't even support requesting permissions
         * to the user, and the application freezes when attempting to do so.
         */
        // braze.requestPushPermission();
        // eslint-disable-next-line no-console
        if (isDevMode()) console.log('Service worker registration successful', registration);
      },
      (error) => {
        Logger.error('Service worker registration failed', `${DATASOURCE.BRAZE}.${FEATURE.NOTIFICATIONS}.${SECTION}.${EVENT.GET_CARD}`, { error });
      },
    );
  }
};
